//      

                                                  
                                    
import {getAllProducts, getProducts, getTopProducts} from "./products";
                                               
import {
	categoryReset,
	menuSet,
	pageIndexReset,
	pageIndexSet,
	searchPhraseSet,
	searchPreviewCleared,
	searchPreviewSet
} from "../reducers/filterReducer";
import {categorySet, searchPhraseSubmitted} from "../reducers/contentReducer";
import ProductApi from "../api/ProductApi";
import {categoryCountsOf, MAX_PREVIEW_PRODUCTS, toSearchPreview, withTotals} from "../helper/searchPreview";

// Typing "anh" fires a request per pause, and the one for "an" must not overwrite the preview for
// "anh" when it comes back late - only the response of the newest request is kept.
let searchPreviewRequestToken = 0;

// What a category page shows does not depend on what has been typed, so the counts are asked for
// once per module and language, not on every keystroke. A failed request is forgotten, the next
// keystroke asks again.
const countCache                            = new Map();

const cachedCount = (key        , request                    )               => {
	if (!countCache.has(key)) {
		countCache.set(key, request().catch(error => {
			countCache.delete(key);
			throw error;
		}));
	}

	return countCache.get(key);
};

export const SPECIAL_CATEGORY = {
	TOP: "top",
	ALL: "all",
	listAll: () => [SPECIAL_CATEGORY.TOP, SPECIAL_CATEGORY.ALL],
};

export const setMenu = (menuOption         ) => {
	return (dispatch          ) => {
		dispatch(menuSet(menuOption));
	};
};

export const setSearchPhrase = (searchPhrase        ) => {
	return (dispatch          ) => {
		dispatch(searchPhraseSet(searchPhrase));
	};
};

export const submitSearchPhrase = (searchPhrase        ) => {
	return (dispatch          , getState                        ) => {
		dispatch(searchPhraseSubmitted(getState().filter.fuzzy));
		dispatch(getProducts());
	};
};

/**
 * The preview under the search box for what has been typed so far: the first products and the
 * categories they belong to. It runs the search the result page runs - under the vehicle of the
 * module and the selected category - so "show all results" keeps its word.
 */
export const getSearchPreview = (typed        ) => {
	return (dispatch          , getState                        ) => {
		const myToken = ++searchPreviewRequestToken;
		const {config, filter} = getState();
		const productApi = new ProductApi(config.dealerId, config.language, config.intent);

		return productApi.getSearchPreview(config, {
			fuzzy: typed,
			categoryKey: filter.filter.selectedCategory ? filter.filter.selectedCategory.key : null,
		}, MAX_PREVIEW_PRODUCTS)
			.then(response => {
				const preview = toSearchPreview(response, typed);
				const scope = JSON.stringify([config.dealerId, config.language, config.vehicle]);

				// a category page shows all of the category under the module's vehicle, which is what
				// the category facet of a search without a phrase counts
				return cachedCount(`${scope}|categories`,
					() => productApi.getSearchPreview(config, {fuzzy: "", categoryKey: null}, 1).then(categoryCountsOf))
					.then(categories => withTotals(preview, categories, {}))
					// without the totals the entries are still worth offering, just without a number
					.catch(() => withTotals(preview, {}, {}));
			})
			.then(preview => {
				if (myToken !== searchPreviewRequestToken) return;
				dispatch(searchPreviewSet(preview));
			})
			.catch(() => {
				// the preview is an offer, not a result: a failed request leaves the plain search box
				if (myToken !== searchPreviewRequestToken) return;
				dispatch(searchPreviewCleared());
			});
	};
};

export const clearSearchPreview = () => {
	searchPreviewRequestToken++;

	return searchPreviewCleared();
};

export const setCategory = (categoryKey         = SPECIAL_CATEGORY.ALL) => {
	return (dispatch          , getState                        ) => {
		const mainCategories             = getState().content.meta.categories;
		const subCategories             = [].concat.apply([], mainCategories.map(cat => cat.categories));
		const selectedCategories             = [...mainCategories, ...subCategories].filter(cat => categoryKey.includes(cat.key));
		let selectedCategory = selectedCategories.length > 0
			? selectedCategories[0]
			: {key: categoryKey, title: categoryKey};

		dispatch(categorySet(selectedCategory));

		if (categoryKey === SPECIAL_CATEGORY.ALL) {
			dispatch(getAllProducts());
		} else if (categoryKey === SPECIAL_CATEGORY.TOP) {
			dispatch(getTopProducts());
		} else {
			dispatch(getProducts());
		}
	};
};

export const resetCategory = () => {
	return (dispatch          ) => {
		dispatch(categoryReset());
	};
};

export const setPage = (page        ) => {
	return (dispatch          ) => {
		dispatch(pageIndexSet(page));
	};
};

export const resetPage = () => {
	return (dispatch          ) => {
		dispatch(pageIndexReset());
	};
};
